import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { fetchCandidateReport } from '../../../services/admin/api';

import PersonalReportSection from './PersonalReportSection';
import AddressDetailsSection from './AddressDetailsSection';
import EducationDetailsSection from './EducationDetailsSection';
import EmploymentDetailsSection from './EmploymentDetailsSection';
import CriminalCheckSection from './CriminalCheckSection';
import EmploymentUANCheckSection from './EmploymentUANCheckSection';
import VerifierDetailsSection from './VerifierDetailsSection';
import ResultOfVerificationSection from './ResultOfVerificationSection';

import './reportStyles.css';

const CandidateReport = () => {
  const { candidateId } = useParams();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const heading = location.state?.heading || 'Candidate Report';

  useEffect(() => {
    const loadReport = async () => {
      try {
        const data = await fetchCandidateReport(candidateId);
        setReportData(data);
      } catch (err) {
        setError('Failed to load report.');
      } finally {
        setLoading(false);
      }
    };

    if (candidateId) {
      loadReport();
    }
  }, [candidateId]);

  if (loading) return (
    <div className="centered-message">
      <div className="spinner"></div>
      <div>Loading Report ...</div>
    </div>
  );
  if (error) return <p className="error">{error}</p>;
  if (!reportData) return <p>No report data found.</p>;

  const {
    personalCheck,
    addressCheck,
    educationCheck,
    employmentCheck,
    criminalCheckRequests,
    employmentUANCheckRequests,
    attachmentResponses,   // extract this
  } = reportData;

  const isSameAddress =
    addressCheck?.sameAsPermanent === true ||
    addressCheck?.sameAsPermanent === "true" ||
    addressCheck?.sameAsPermanent === 1;

  return (
    <div className="report-container">
      <PersonalReportSection personalData={personalCheck} />

      {/* <AddressDetailsSection
        title="Current Address Details"
        addressData={addressCheck && {
          addressLineOne: addressCheck.currentAddressLine1,
          addressLineTwo: addressCheck.currentAddressLine2,
          country: addressCheck.currentCountry,
          state: addressCheck.currentState,
          city: addressCheck.currentCity,
          pincode: addressCheck.currentPinCode,
          mobileNumber: addressCheck.currentMobileNumber,
          verificationUrls: addressCheck.currentAddressFileName
        }}
      />

      <AddressDetailsSection
        title="Permanent Address Details"
        addressData={addressCheck && {
          addressLineOne: addressCheck.permanentAddressLine1,
          addressLineTwo: addressCheck.permanentAddressLine2,
          country: addressCheck.permanentCountry,
          state: addressCheck.permanentState,
          city: addressCheck.permanentCity,
          pincode: addressCheck.permanentPinCode,
          mobileNumber: addressCheck.permanentMobileNumber,
          verificationUrls: addressCheck.permanentAddressFileName
        }}
      /> */}

      {addressCheck?.sameAsPermanent ? (
  // ✅ SHOW ONLY ONE ADDRESS
  <AddressDetailsSection
    title="Address Details"
    addressData={{
      addressLineOne: addressCheck.currentAddressLine1,
      addressLineTwo: addressCheck.currentAddressLine2,
      country: addressCheck.currentCountry,
      state: addressCheck.currentState,
      city: addressCheck.currentCity,
      pincode: addressCheck.currentPinCode,
      mobileNumber: addressCheck.currentMobileNumber,
      verificationUrls: addressCheck.currentAddressFileName
    }}
  />
) : (
  // ❌ SHOW BOTH
  <>
    <AddressDetailsSection
      title="Current Address Details"
      addressData={{
        addressLineOne: addressCheck.currentAddressLine1,
        addressLineTwo: addressCheck.currentAddressLine2,
        country: addressCheck.currentCountry,
        state: addressCheck.currentState,
        city: addressCheck.currentCity,
        pincode: addressCheck.currentPinCode,
        mobileNumber: addressCheck.currentMobileNumber,
        verificationUrls: addressCheck.currentAddressFileName
      }}
    />

    <AddressDetailsSection
      title="Permanent Address Details"
      addressData={{
        addressLineOne: addressCheck.permanentAddressLine1,
        addressLineTwo: addressCheck.permanentAddressLine2,
        country: addressCheck.permanentCountry,
        state: addressCheck.permanentState,
        city: addressCheck.permanentCity,
        pincode: addressCheck.permanentPinCode,
        mobileNumber: addressCheck.permanentMobileNumber,
        verificationUrls: addressCheck.permanentAddressFileName
      }}
    />
  </>
)}

      <EducationDetailsSection educationChecks={educationCheck} />

      {/* Pass both employmentCheck and attachmentResponses */}
      <EmploymentDetailsSection
        employmentChecks={employmentCheck}
        attachmentResponses={attachmentResponses}
      />

      <CriminalCheckSection criminalChecks={criminalCheckRequests} />
      <EmploymentUANCheckSection uanChecks={employmentUANCheckRequests} />

      <VerifierDetailsSection verifierData={null} />

      <ResultOfVerificationSection
        candidateId={candidateId}
        personalVerificationStatus={personalCheck?.verificationStatus}
      />
    </div>
  );
};

export default CandidateReport;